import initialState from './initialState';
import produce from 'immer';

export default (state = initialState.clock, action) => {
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.clock;
		//
		case 'SET_CLOCK':
			return produce(state, (draft) => {
				draft.value = action.value;
			});

		// case 'SHOW_CLOCK':
		// 	return produce(state, (draft) => {
		// 		if (action.position === 'bottom') {
		// 			draft.active = action.value;
		// 		}
		// 	});

		case 'SET_TURN_DURATION':
			return produce(state, (draft) => {
				draft.turnDuration = action.value;
			});

		case 'SET_PLAYER_COUNT':
			return produce(state, (draft) => {
				draft.playerCount = action.value;
			});

		case 'SET_ROOM_URL':
			return produce(state, (draft) => {
				draft.roomURL = action.value;
			});

		case 'SHOW_CHEAT_VOTE':
			return produce(state, (draft) => {
				draft.showCheatVote = action.value;
			});
		default:
			return state;
	}
};
